import React from "react";

interface DeleteChoiceIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
}

const DeleteChoiceIcon: React.FC<DeleteChoiceIconProps> = ({
  size = 22,
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M6 11H16"
      stroke="#D33E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DeleteChoiceIcon;
